module.exports = "https://cdn.qantashotels.com/qpcustomerui/_next/static/images/logo-light-1a166fed52e57e9ad033fa469326bbdb.svg";